export default {
    path: '/msgcontent',
    meta: {
        title: '推送详情',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/msgcontent`),
}


// WEBPACK FOOTER //
// ./src/views/MsgContent/router.js